<template>
  <div>
    <div>Filters:</div>
    <div>
      <treeselect
        :multiple="true"
        :searchable="true"
        :open-on-focus="true"
        :show-count="true"
        :options="options"
        :disable-branch-nodes="true"
        :clear-on-select="true"
        :placeholder="$t('filters')"
        :limit-text="limitText"
        value-consists-of="ALL_WITH_INDETERMINATE"
        @input="handleInput"
      >
        <div slot="value-label" slot-scope="{ node }">
          {{ node.raw.column }}:
          {{
            node.raw.label.length > 15
              ? node.raw.label.substring(0, 15) + "..."
              : node.raw.label
          }}
        </div>
      </treeselect>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableColumnsFilter",
  components: {
    treeselect: () => import("@riophae/vue-treeselect"),
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedFilters: [],
    }
  },
  computed: {
    filterableColumns() {
      return this.columns.filter((column) => column.filterable)
    },
    options() {
      return this.filterableColumns.map((column) => {
        return {
          id: column.key,
          label: column.label,
          children: this.getDistinctValues(column.key).map((rowValue) => {
            return {
              id: `${rowValue.column}-${rowValue.value}`,
              label: rowValue.value,
              column: rowValue.column,
            }
          }),
        }
      })
    },
  },
  methods: {
    limitText(count) {
      return this.$t("and {count} more").replace("{count}", count)
    },
    getDistinctValues(key) {
      return this.rows
        .map((row) => ({ value: row[key], column: key }))
        .filter((row, index, self) => {
          return self.findIndex((r) => r.value === row.value) === index
        })
    },
    handleInput(selectedValues) {
      const newFilterValues = {}

      for (const selectedValue of selectedValues) {
        // split on first -
        const [column, value] = selectedValue.split("-", 2)
        if (newFilterValues[column]) {
          newFilterValues[column].push(value)
        } else {
          newFilterValues[column] = [value]
        }
      }

      // remove empty filters
      for (const key in newFilterValues) {
        if (newFilterValues[key].length === 0) {
          delete newFilterValues[key]
        }
      }

      this.$emit("input", newFilterValues)
    },
  },
}
</script>

<style scoped></style>
